module.exports = __webpack_public_path__ + "static/media/icn-video.7deec397.svg";